<template>
  <div class="picker">
    <el-select v-model="value" placeholder="请选择" @change="changed">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
  </div>

</template>

<script>
  export default {
    name: "picker",
    props: {
      options: {
        type: Array,
        defaule: ()=>[]
      }
    },
    data() {
      return {
        value: this.options[0].value
      }
    },
    computed: {

    },
    watch: {

    },

    mounted() {
      this.$emit('change', this.value)
    },
    methods: {
      changed(val) {
        this.$emit('change', val)
      },
    }
  }
</script>

<style lang="scss">
  .picker {
    --borColor: #00a2a1;
    --fontSize: 12px;

    color: #bffffb;
    margin-right: 10px;
    .el-select {
      width: 120px;
      .el-input {
        .el-input__inner {
          color: #bffffb;
          font-size: 12px;
          height: 22px;
          background-color: #04393c;
          border: 1px #00a2a1 solid;
          border-radius: 13px;
        }
        .el-select__caret {
          color: #00a2a1;
        }
      }
      .el-input.is-focus {
        .el-input__inner {
          border-color: #00a2a1;
        }
      }
    }
  }

  .el-select-dropdown {
    color: #bffffb;
    background-color: #04393c;
    border: 1px #00a2a1 solid;
    .el-scrollbar {
      .el-select-dropdown__item {
        color: #bffffb;
        font-size: 12px;
        /*height: 22px;*/
        padding: 2px 10px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/picker.vue